export const BillingRunStatus = {
  DRAFT: "DRAFT",
  EXPORTED: "EXPORTED",
  FINISHED: "FINISHED",
  DELETED: "DELETED",
};

export const BillingRunStatusOptions = [
  {
    label: "Draft",
    value: BillingRunStatus.DRAFT,
  },
  {
    label: "Exported",
    value: BillingRunStatus.EXPORTED,
  },
  {
    label: "Deleted",
    value: BillingRunStatus.DELETED,
  },
  {
    label: "Finished",
    value: BillingRunStatus.FINISHED,
  },
];

export const BillingRunPermissions = {
  delete: "BillingRunPermissions.delete",
  read: "BillingRunPermissions.read",
  update: "BillingRunPermissions.update",
};

// Sale Sub Type name (as returned by the API) to the matching system rule
// book cbid key on the heartbeat payload. Mirrors
// CLEARING_SALE_RULE_BOOK_SETTING_BY_SUB_TYPE_NAME in the backend.
export const ClearingSaleRuleBookIdKeyBySubTypeName = {
  "A+ ONLINE ONLY": "clearingSaleAPlusOnlineOnlyRuleBookId",
  "ON FARM - A+ INTERFACED": "clearingSaleOnFarmAPlusInterfacedRuleBookId",
  "ON FARM ONLY": "clearingSaleOnFarmOnlyRuleBookId",
};
